import React, { useEffect } from "react";
import http from "../services/httpService";
import SearchBar from "material-ui-search-bar";
import { TablePagination } from "@material-ui/core";
import { useState } from "react";
import { getDate, getDateTime, searchFilter } from "../utils/varialbles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import toast from "react-hot-toast";

export default function Cdtadvicessent() {
  const [totalRowCount, setTotalRowCount] = useState("");
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);

  const columns = [
    { id: "userid", label: "User Id", minWidth: 150 },
    { id: "mobile", label: "Mobile No", minWidth: 150 },
    { id: "name", label: "Name", minWidth: 150 },
    { id: "emp", label: "Employee", minWidth: 150 },
    { id: "freq", label: "Frequency", minWidth: 150 },
    { id: "date", label: "Date", minWidth: 150, type: "date" },
    { id: "efg", label: "EFG", minWidth: 150 },
    { id: "elss", label: "ELSS", minWidth: 150 },
    { id: "country", label: "Country", minWidth: 150 },
    { id: "amount", label: "Amount", minWidth: 150 },
    { id: "comment", label: "Comment", minWidth: 150 },
  ];

  // const getPaginationURL = (url, newQuery) => {
  //   const query = newQuery === "" ? newQuery : searched;
  //   if (query) {
  //     return `${url}?page=${
  //       page + 1
  //     }&rowsPerPage=${rowsPerPage}&search=${query}`;
  //   } else {
  //     return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}&page_type=A`;
  //   }
  // };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const getData = (newQuery) => {
    const baseURL = `/CDTinvreqs?page=${
      page + 1
    }&rowsPerPage=${rowsPerPage}&page_type=A`;
    toast.loading("Please wait");
    http
      .get(baseURL)
      .then((res) => {
        toast.dismiss();
        if (res.data.statusCode === 0) {
          setRows(res.data.Data);
          const tempdata = res.data.Data;
          setOriginalRows(tempdata);
          setTotalRowCount(res.data.totalRowCount);
        } else {
          setRows([]);
          setOriginalRows([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage]);
  return (
    <div>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        className={"mt30"}
      />
      <TablePagination
        rowsPerPageOptions={[10, 50, 100, 1500]}
        component="div"
        count={totalRowCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((item, index) => {
                return <TableCell>{item.label}</TableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length !== 0 ? (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  return (
                    <TableRow>
                      {columns.map((cols, index) => {
                        const value = item[cols.id];
                        return (
                          <TableCell>
                            {cols.type === "date"
                              ? getDateTime(value)
                              : value
                              ? value
                              : "N/A"}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
            ) : (
              <p>No data available</p>
            )}
            <></>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
